/* Language selector fix for dynamic search results pages. */

$(function () {
    if (window.location.pathname.match(/^\/[^\/]+\/search\/$/)) {
        $(".language-selector a").each(function () {
            this.href = this.href + "search/" + window.location.search;
        });
    }
});
